import DateRangeSelector from "pages/dashboard-overview/components/DateRangeSelector";
import useHttp from "hooks/useHttp";
import useAnalyticsFilters from "hooks/useAnalyticsFilters";
import ExpenseAnalytics from "pages/analytics/components/ExpenseAnalytics";

export default function FinanceExpenseAnalyticsPage() {
  const api = useHttp();
  const { filters, dateRange, setDateRange, customRange, setCustomRange } =
    useAnalyticsFilters("thisMonth");

  return (
    <>
      <div className="mb-4 flex flex-col gap-4 sm:flex-row sm:justify-between">
        <DateRangeSelector
          selected={dateRange}
          onChange={setDateRange}
          customRange={customRange}
          onCustomRangeChange={setCustomRange}
        />
      </div>

      <ExpenseAnalytics api={api} filters={filters} financeMode />
    </>
  );
}
